<template>
  <div class="app-container">
    <div class="flex justify-between items-center mb-4">
      <el-form ref="queryForm"
               :model="queryParams"
               :inline="true"
               label-width="68px">
        <el-form-item label="公司名称"
                      prop="companyName">
          <el-input v-model="queryParams.companyName"
                    placeholder="请输入公司名称"
                    clearable
                    size="small" />
        </el-form-item>

        <el-form-item label="公司码值"
                      prop="companyCode">
          <el-input v-model="queryParams.companyCode"
                    placeholder="请输入公司码值"
                    clearable
                    size="small" />
        </el-form-item>

        <el-form-item>
          <el-button type="primary"
                     icon="el-icon-search"
                     :loading="loading"
                     size="mini"
                     @click="handleQuery">查询</el-button>
          <el-button icon="el-icon-refresh" size="mini" @click="resetQuery">重置</el-button>
        </el-form-item>
      </el-form>
      
      <el-button type="primary"
                 icon="el-icon-plus"
                 size="mini"
                 v-show="admin"
                 @click="handleAdd">新建公司</el-button>
    </div>
    
  <div class="gap"></div>
    <el-table v-loading="loading"
              :data="list">
      <el-table-column label="公司名称"
                       label-class-name="title"
                       align="center"
                       prop="companyName" />
      <el-table-column label="公司码值"
                       label-class-name="title"
                       align="center"
                       prop="companyCode" />
      <el-table-column label="联系人"
                       label-class-name="title"
                       align="center"
                       prop="contactPerson" />
      <el-table-column label="联系电话"
                       label-class-name="title"
                       align="center"
                       prop="contactPhone" />
      <el-table-column label="公司地址"
                       label-class-name="title"
                       align="center"
                       prop="address" />
      <el-table-column label="管理员用户名"
                       label-class-name="title"
                       align="center"
                       prop="username" />
      <!-- <el-table-column label="管理员姓名"
                       label-class-name="title"
                       align="center"
                       prop="adminName" /> -->
      <el-table-column label="操作"
                       align="center"
                       label-class-name="title"
                       class-name="small-padding fixed-width">
        <template slot-scope="scope">
          <el-button class="inspect-button"
                     size="mini"
                     type="text"
                     icon="el-icon-view"
                     @click="handleView(scope.row)">查看</el-button>
          <el-button class="inspect-button"
                     size="mini"
                     type="text"
                        v-show="admin"
                     icon="el-icon-edit"
                     @click="handleUpdate(scope.row)">修改</el-button>
          <el-button class="inspect-button"
                     size="mini"
                     type="text"
                        v-show="admin"
                     icon="el-icon-delete"
                     @click="handleDelete(scope.row.id)">删除</el-button>
        </template>
      </el-table-column>

    </el-table>
    <el-pagination
      v-show="total>0"
      :total="total"
      @current-change="getList"
      @prev-click = 'getList'
      @next-click="getList"
    />

    <!-- 公司信息编辑 -->
    <el-dialog title="公司信息"
               :visible.sync="open"
               :close-on-click-modal="false"
               width="700px"
               append-to-body>
      <el-form ref="form"
               :model="form"
               label-width="100px"
               size="mini">
        <el-row>
          <el-col :span="12">
            <el-form-item label="公司名称" required>
              <el-input v-model="form.companyName"
                        :disabled='disabled'
                        clearable
                        size="small" placeholder="请输入公司名称" />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="公司码值" required>
              <el-input v-model="form.companyCode"
                       :disabled='disabled'
                        clearable
                        size="small" placeholder="请输入公司码值" />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="联系人" required>
              <el-input v-model="form.contactPerson"
                        :disabled='disabled'
                        clearable
                        size="small" placeholder="请输入联系人" />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="联系电话" required>
              <el-input v-model="form.contactPhone"
                        :disabled='disabled'
                        clearable
                        size="small" placeholder="请输入联系电话" />
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="公司地址">
              <el-input v-model="form.address"
                        :disabled='disabled'
                        clearable
                        size="small" placeholder="请输入公司地址" />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="用户名" required>
              <el-input v-model="form.username"
                        aria-disabled
                          :disabled='disabled'
                        size="small" placeholder="请输入管理员用户名" />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="密码" required>
              <el-input v-model="form.password"
                        :disabled='disabled'
                        type="password"
                        clearable
                        size="small" placeholder="请输入管理员密码" />
            </el-form-item>
          </el-col>
          <!-- <el-col :span="12">
            <el-form-item label="管理员姓名" required>
              <el-input v-model="form.adminName"
                        :disabled='disabled'
                        clearable
                        size="small" placeholder="请输入管理员姓名" />
            </el-form-item>
          </el-col> -->
        </el-row>
      </el-form>
      <div slot="footer"
           class="dialog-footer">
        <el-button type="primary"
                   :disabled='disabled'
                   @click="submit">确定</el-button>
        <el-button @click="open = false">关闭</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { addCompany, getCompanyList, updateCompany, deleteCompany } from '../api/company/index'
export default {
  name: 'CompanyManage',
  data () {
    return {
      admin:'',
      pageIndex: 1,
      pageSize: 10,
      // 禁用状态
      disabled: false,
      queryParams: {},
      loading: false,
      // table 列表数据
      list: [],
      // 总条数
      total: 0,
      // dialog 弹框
      open: false,
      // 弹框 表单
      form: {}
    }
  },
  created () {
    this.handleQuery();
       debugger
    console.log(1111111)
    let admin = localStorage.getItem('userInfo')
    if(admin){
      admin = JSON.parse(admin)
    }
    this.admin = admin.role == 'superadmin'
    console.log(this.admin)
  },
  methods: {
    //  退出
    logout() {
      localStorage.clear();
      this.$router.push('/')
    },
    // 新增按钮
    handleAdd () {
      this.open = true
      this.disableFun(false)
      this.form = {}
    },
    // 确定按钮
    submit () {
      console.log(this.form)
      // 表单验证
      if (!this.form.companyName) {
        return this.$message.error('请输入公司名称');
      }
      if (!this.form.companyCode) {
        return this.$message.error('请输入公司码值');
      }
      if (!this.form.contactPerson) {
        return this.$message.error('请输入联系人');
      }
      if (!this.form.contactPhone) {
        return this.$message.error('请输入联系电话');
      }
      if (!this.form.username) {
        return this.$message.error('请输入管理员用户名');
      }
      if (!this.form.password) {
        return this.$message.error('请输入管理员密码');
      }
      // if (!this.form.adminName) {
      //   return this.$message.error('请输入管理员姓名');
      // }

      if (!this.form.id) {
        // 新增公司
        addCompany(this.form).then(res => {
          if (res.code == '200') {
            this.$message.success('新增成功')
            this.open = false
            this.handleQuery()
          } else {
            this.$message.error('服务异常');
          }
        })
      } else {
        // 修改公司
        updateCompany(this.form).then(res => {
          console.log(res)
          this.open = false
          this.$message.success('修改成功')
          this.handleQuery()
        })
      }
    },
    // 查看
    handleView (row) {
      this.open = true
      this.form = Object.assign({}, row)
      this.disableFun(true)
    },
    // 修改按钮
    handleUpdate (row) {
      this.handleView(row)
      this.disableFun(false)
    },
    /**
     * @desc 禁用逻辑
     * @param {Boolean}
    */
    disableFun (Blean) {
      this.disabled = Blean
    },
    // 查询按钮
    handleQuery () {
      let data = {
        pageIndex: this.pageIndex,
        pageSize: this.pageSize,
        ...this.queryParams
      }
      this.loading = true
      getCompanyList(data).then(res => {
        this.loading = false
        console.log('getCompanyList返回数据:', res)
        if (res.code == '200') {
          console.log('数据列表:', res.data)
          console.log('总条数:', res.total)
          this.list = res.data;
          this.total = res.total
          console.log('赋值后list:', this.list)
          console.log('赋值后total:', this.total)
        } else {
          this.$message.error('获取数据失败');
        }
      }).catch(err => {
        this.loading = false
        console.error('请求错误:', err)
        this.$message.error('网络错误');
      })
    },
    // 删除按钮
    handleDelete (id) {
      this.$confirm('确定要删除此公司吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        let obj = { id: id }
        deleteCompany(obj).then(res => {
          if (res.code == '200') {
            this.$message.success('删除成功')
            this.handleQuery()
          } else {
            this.$message.error('删除失败');
          }
        })
      }).catch(() => {
        // 取消删除
      })
    },
    // 重置查询
    resetQuery () {
      this.queryParams = {}
      this.handleQuery()
    },
    // 获取列表
    getList (e) {
      this.pageIndex = e
      this.handleQuery()
    }
  },
}
</script>
<style>
.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}
.avatar-uploader .el-upload:hover {
  border-color: #409eff;
}
.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 178px;
  height: 178px;
  line-height: 178px;
  text-align: center;
}
.avatar {
  width: 178px;
  height: 178px;
  display: block;
}
.gap{
  margin: 30px 10px;
}
.title{
  color: black;
}
.flex {
  display: flex;
}
.justify-between {
  justify-content: space-between;
}
.items-center {
  align-items: center;
}
.mb-4 {
  margin-bottom: 16px;
}
</style>



// WEBPACK FOOTER //
// src/infoManage/index.vue